import styled from "styled-components";
import React from "react";
import media from "Styles/media";
interface TitleProps {
	value: string;
	className?: string;
	type?: TitleType;
	div?: boolean;
	align?: "left" | undefined | "right" | "center";
}
export enum TitleType {
	LG,
	MD,
	SM
}

const Wrapper = styled.div<{ align?: string | undefined }>`
	color: ${(props) => props.theme.color.white};
	/* font-weight: bolder; */
	font-family: ${(props) => props.theme.font.inconsolata};
	padding: 12px 0;
	text-transform: uppercase;
	line-height: 1.5;
	text-align: ${(props) => props.align};
`;

const TextLg = styled.h1`
	font-size: 40px;
	@media ${media.tablet} {
		font-size: 32px;
	}
`;
const TextMd = styled.h2`
	font-size: 24px;
`;

const TextSm = styled.h3`
	font-size: 20px;
`;

const Div = styled.div`
	width: 20px;
	height: 2px;
	background-color: #fff;
	display: inline-block;
	margin: 24px 0;
	margin-bottom: 12px;
`;

const Title: React.FC<TitleProps> = ({ value, className, type = TitleType.LG, align, div }) => {
	const renderText = (type: TitleType) => {
		switch (type) {
			case TitleType.MD: {
				return <TextMd className={className}>{value}</TextMd>;
			}
			case TitleType.SM: {
				return <TextSm className={className}>{value}</TextSm>;
			}
			default: {
				return <TextLg className={className}>{value}</TextLg>;
			}
		}
	};

	return (
		<Wrapper className={className} align={align}>
			{renderText(type)}
			{div && <Div />}
		</Wrapper>
	);
};

export default Title;
